<template>
	<Modal @close="closeModal" v-if="showModal" :draggable="false">
		<template slot="title">Add User Defined Group</template>
		<template slot="body">
			<div style="width:500px; height:100px;" v-on:keyup.esc="close()">
				<table class="view_tbl">
					<tbody>
						<tr>
							<th>Name</th>
							<td><input type="text" v-model.trim="ud.name" class="tbl_int" /></td>
						</tr>
						<tr>
							<th>Order No</th>
							<td>
								<currency-input type="text" v-model.trim="ud.orderNo" :precision="0" class="tbl_int ssm_int al_right" />
							</td>
						</tr>
					</tbody>
				</table>
				<div class="popup_bottom">
					<a href="javascript:void(0);" @click="add()" class="search_bt">Save & Close</a>
					<a href="javascript:void(0);" @click="closeModal()" class="gray_bt">Cancel</a>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '@/components/common/Modal';
import { apiInertUserDefinedGroup, apiUpdateUserDefinedGroup, apiSelectUserDefinedGroup, apiSelectUserDefinedGroupByName } from '@/api/item/userDefined';
import { objectToFormData, objectToUrlParam } from '@/api/util';

export default {
	name: 'UserDefinedGroupPop',
	data: function() {
		return {
			ud: {
				udNo: 0,
				name: '',
				orderNo: 0,
			},
			showModal: false,
		};
	},
	components: {
		Modal,
	},
	methods: {
		initialState() {
			return {
				ud: {
					udNo: 0,
					name: '',
					orderNo: 0,
				},
				showModal: false,
			};
		},
		closeModal() {
			Object.assign(this.$data, this.initialState());
		},
		openModal() {
			this.showModal = true;
		},
		async selectUserDefinedGroup(ud_no) {
			if (ud_no) {
				const { data } = await apiSelectUserDefinedGroup(ud_no);
				this.ud = data;
			}
		},
		async add() {
			const vm = this;
			if (this.ud.name.split('|').length > 1) {
				this.$toast.error('You cannot enter "|" in the name.');
				return false;
			}
			if (this.ud.name.length <= 0) {
				this.$toast.error('Name is empty');
				return false;
			}

			const { data } = await apiSelectUserDefinedGroupByName(objectToUrlParam({ name: this.ud.name, ud_no: this.ud.udNo }));
			if (data) {
				this.$toast.error('Duplicate Name.');
				return false;
			}

			let param = objectToFormData({ name: vm.ud.name, orderNo: vm.ud.orderNo });
			let udNoForEmit = 0;
			if (this.ud.udNo) {
				await apiUpdateUserDefinedGroup(vm.ud.udNo, param);
				this.$toast.success('Insert Complete');
				udNoForEmit = this.ud.udNo;
			} else {
				let { data } = await apiInertUserDefinedGroup(param);
				this.$toast.success('Update Complete');
				udNoForEmit = data.udNo;
			}
			this.$emit('change', udNoForEmit);

			this.closeModal();
		},
	},
};
</script>

<style scoped></style>
